import React, { useCallback, useEffect, useState } from 'react';
import UIEventBus from '../EventBus';

interface FreeCamToggleProps { }

const FreeCamToggle: React.FC<FreeCamToggleProps> = ({ }) => {
    const [freeCamActive, setFreeCamActive] = useState(false);
    const [blockEvents, setBlockEvents] = useState(true);

    const onMouseDownHandler = useCallback(
        (event: React.MouseEvent) => {
            event.preventDefault();
            setFreeCamActive(!freeCamActive);
        },
        [freeCamActive]
    );

    useEffect(() => {
        setTimeout(() => setBlockEvents(false), 100);
    }, []);

    useEffect(() => {
        if (!blockEvents) {
            window.postMessage({ type: 'keydown', key: `_AUTO_` }, '*');
            UIEventBus.dispatch('freeCamToggle', freeCamActive);
        }
    }, [freeCamActive]);

    return (
        <button
            className="macos-pill-button"
            onMouseDown={onMouseDownHandler}
            id="prevent-click"
            title={freeCamActive ? 'Exit Free Camera' : 'Free Camera'}
            style={{
                border: freeCamActive ? '1px solid rgba(10,132,255,0.6)' : 'none',
                background: freeCamActive ? 'rgba(10,132,255,0.3)' : undefined,
            }}
        >
            {freeCamActive ? <MouseIcon /> : <CameraIcon />}
        </button>
    );
};

const CameraIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23 7l-7 5 7 5V7z" fill="rgba(255,255,255,0.85)" />
        <rect x="1" y="5" width="15" height="14" rx="2" ry="2" fill="none" stroke="rgba(255,255,255,0.85)" strokeWidth="1.5" />
    </svg>
);

const MouseIcon = () => (
    <svg width="12" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="5" y="2" width="14" height="20" rx="7" fill="none" stroke="rgba(255,255,255,0.85)" strokeWidth="1.5" />
        <path d="M12 2v8" stroke="rgba(255,255,255,0.85)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

export default FreeCamToggle;
